<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SmartOfferBundleAnyPurchaseType} from "@/modules/redactor/models/smart-offer/bundle-any-purchase/SmartOfferBundleAnyPurchaseType";

export default {
  name: "r-smart-offer-bundle-any-purchase-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleAnyPurchaseType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleAnyPurchaseType.getValues();
    }
  }
}
</script>